// import React, { useState, useEffect } from 'react';
// import { useParams, Link, useLocation } from 'react-router-dom';
// import axios from 'axios';
// import { useAuth } from '../../AuthContext';
// import { Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Rating, Tooltip } from '@mui/material';
// import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
// import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import Header1 from '../Header/Header1';
// import Footer from '../Footer/Footer';
// import ThumbUpIcon from '@mui/icons-material/ThumbUp';
// import ThumbDownIcon from '@mui/icons-material/ThumbDown';
// import ReportIcon from '@mui/icons-material/Report';
// import ShareButton from "../Share/ShareButton";
// import Footer2 from '../Footer/Footer2';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import PostRecommendations from '../Recommendations/PostRecommendations';
// import avatar from './default-avatar.png'
// import ShareIcon from '@mui/icons-material/Share';
// import FlagIcon from '@mui/icons-material/Flag';
// import { styled } from '@mui/system';
// import OTPValidation from '../OTP/OTPValidation';
// import FeedbackFormMyBookings from '../Feedback/FeedbackFormMyBookings';
// import GoogleMeetLogo from './GoogleMeetImage.png';
// import ZoomMeetLogo from './ZoomMeetImage.png';
// import TeamsMeetLogo from './TeamsMeetImage.png';
// import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
// import CancelSessionPostBookingButton from '../Cancellations/CancellSessionPostBookingButton';
// import ViewsLikesAnalytics from './ViewsLikesAnalytics';
// import MeetingGuidelines from '../Guidelines/MeetingGuidelines';
// import JoinAsSubscriberButton from '../Agora/JoinAsSubscriberButton';
// import { formatDateWithSuffix } from '../utils/formatDate';
// import { formatTimeToAMPM } from '../utils/formatTime';
// import CircularProgress from '@mui/material/CircularProgress';


// const API_URL = process.env.REACT_APP_API_URL;


// const MyBookingTabDetails = ({ onLogout }) => {

//   useEffect(() => {
//     window.scrollTo(0, 0);  // Scroll to top when this page is loaded
//   }, []);


//   const { id, bookingId } = useParams();
//   const { userId } = useAuth();
//   const navigate = useNavigate();
//   const [course, setCourse] = useState(null);
//   const [action, setAction] = useState(null);
//   const location = useLocation();
//   const [bookingCreated, setBookingCreated] = useState(false)
//   const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided
//   // number of recommendations to fetch

//   const [openDialog, setOpenDialog] = useState(false); // To control the dialog's visibility
//   const [isChecked, setIsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//       const [loadingSeconds, setLoadingSeconds] = useState(0);

//   const [booking, setBooking] = useState(null);

// useEffect(() => {
//   const fetchBooking = async () => {
//     try {
//       const res = await fetch(
//         `${API_URL}/get_booking_details/?booking_id=${bookingId}`
//       );

//       if (!res.ok) {
//         const text = await res.text();
//         console.error("API ERROR:", text);
//         return;
//       }

//       const data = await res.json();
//       setBooking(data);

//     } catch (err) {
//       console.error("Booking fetch error:", err);
//     }
//   };

//   if (bookingId) fetchBooking();
// }, [bookingId]);

//   useEffect(() => {
//           let timer;
        
//           if (loading) {
//             setLoadingSeconds(0); // reset timer
//             timer = setInterval(() => {
//               setLoadingSeconds(prev => prev + 1);
//             }, 1000);
//           } else {
//             clearInterval(timer);
//             setLoadingSeconds(0); // optional reset after done
//           }
        
//           return () => clearInterval(timer); // cleanup on unmount or loading = false
//         }, [loading]);


//   // console.log('booking_iid', bookingId)

// //   useEffect(() => {
// //   const fetchData = async () => {
// //     setLoading(true); // Start loading

// //     try {
// //       const response = await axios.get(`${API_URL}/get_posted_data/`, {
// //         params: { post_id: id },
// //       });

// //       setCourse(response.data[0]);
// //       await createRecentActivity(userId, id); // Log recent activity
// //     } catch (error) {
// //       console.error('Error fetching data:', error);
// //     } finally {
// //       setLoading(false); // Stop loading
// //     }
// //   };

// //   if (id && userId) {
// //     fetchData();
// //   }
// // }, [id, userId]);
//  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once

//   const getLogo = (platform) => {
//     switch (platform) {
//       case 'googleMeet':
//         return GoogleMeetLogo;
//       case 'zoom':
//         return ZoomMeetLogo;
//       case 'microsoftTeams':
//         return TeamsMeetLogo;
//       default:
//         return null; // Optionally, you can return a default image or a placeholder here
//     }
//   };


//   const getPlatformName = (platform) => {
//     switch (platform) {
//       case 'googleMeet':
//         return 'Google Meet';
//       case 'zoom':
//         return 'Zoom';
//       case 'microsoftTeams':
//         return 'Microsoft Teams';
//       default:
//         return null;
//     }
//   };


// //   useEffect(() => {
// //   const getUserPostInteraction = async () => {
// //     setLoading(true); // Start loading

// //     try {
// //       const response = await axios.get(`${API_URL}/get_user_post_interaction/`, {
// //         params: {
// //           user_id: userId,
// //           post_id: id,
// //         },
// //       });
// //       setAction(response.data.action); // Set the action (like, dislike, or null)
// //     } catch (error) {
// //       setAction(null);
// //       console.error("Error fetching user post interaction:", error);
// //     } finally {
// //       setLoading(false); // Stop loading
// //     }
// //   };

// //   if (userId && id) {
// //     getUserPostInteraction();
// //   }
// // }, [userId, id]);
//   useEffect(() => {
//   // 🔥 TEMP: disable API while using dummy data
//     setAction(null);
//    }, [id]);


//   const handleLogout = () => {
//     onLogout();
//     navigate('/login');
//   };












//  const createRecentActivity = async (userId, postId) => {
//   setLoading(true); // Start loading

//   try {
//     const response = await fetch(`${API_URL}/create_recent_activity/`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         user_id: userId,
//         post_id: postId,
//       }),
//     });

//     const data = await response.json();
//     if (!response.ok) {
//       console.error('Error logging recent activity:', data);
//     }
//   } catch (error) {
//     console.error('Error calling create_recent_activity API:', error);
//   } finally {
//     setLoading(false); // Stop loading
//   }
// };


//   if (!booking) {
//   return (
//     <>
//       <Typography variant="h6" sx={{ textAlign: "center", padding: "2rem" }}>
//         Loading...
//       </Typography>

//       <Box
//         sx={{
//           position: 'fixed',
//           top: 0,
//           left: 0,
//           width: '100vw',
//           height: '100vh',
//           backgroundColor: 'rgba(0, 0, 0, 0.5)',
//           zIndex: 2000,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backdropFilter: 'blur(3px)',
//         }}
//       >
//         <Box sx={{ textAlign: 'center' }}>
//           <CircularProgress
//             size={60}
//             thickness={6}
//             sx={{
//               color: 'transparent',
//               '& .MuiCircularProgress-circle': {
//                 stroke: 'url(#better-gradient)',
//               },
//             }}
//           />

//           {/* Gradient definition */}
//           <svg width="0" height="0">
//             <defs>
//               <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
//                 <stop offset="0%" stopColor="#f30b96ff" />
//                 <stop offset="50%" stopColor="#221ce0ff" />
//                 <stop offset="100%" stopColor="#0eacebff" />
//               </linearGradient>
//             </defs>
//           </svg>

//           <Typography
//             variant="h6"
//             sx={{
//               mt: 2,
//               color: '#fff',
//               textShadow: '0 1px 3px rgba(0,0,0,0.7)',
//             }}
//           >
//             Loading Session Details... ({loadingSeconds} sec)
//           </Typography>
//         </Box>
//       </Box>
//     </>
//   );
// }


//   const formatStartTime = (time) => {
//     const [hours, minutes] = time.split(':');
//     const dateObj = new Date();
//     dateObj.setHours(hours);
//     dateObj.setMinutes(minutes);

//     // Format using Intl.DateTimeFormat
//     const formatter = new Intl.DateTimeFormat('en-US', {
//       hour: '2-digit', minute: '2-digit', hour12: true
//     });

//     return formatter.format(dateObj); // returns time in AM/PM format
//   }

//   const formatDuration = (durationInMinutes) => {
//     const hours = Math.floor(durationInMinutes / 60);
//     const minutes = durationInMinutes % 60;

//     // If duration is less than an hour, only show minutes
//     if (hours > 0) {
//       return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
//     }

//     return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
//   };

//   const formatExperience = (experience) => {
//     // If experience exists and is in the format HH:MM
//     if (experience) {
//       let minutes = experience.split(':')[0];  // Extract the minute value before ":"
//       return `${minutes} min`;
//     } else {
//       return "New user";  // If no experience, return "New user"
//     }
//   }


//   // const {
//   //   topic_name, section_name, subsection_name, description, language, date, start_time,
//   //   duration, seats_left, total_seats, name, surname, profile_picture,
//   //   about, rating, experience, id: cardId, price, user_id, meeting_link,
//   //   facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, post_rating, comments, meeting_platform, is_active, media_url, media_type
//   // } = course;
//   const topic_name = booking?.topic_name;
// const date = booking?.date;
// const start_time = booking?.time;
// const duration = booking?.duration;
// const expert_name = booking?.expert_name;
// const recording_url = booking?.recording_url;
// const status = booking?.status;

//   // const durationFormatted = duration ? `${Math.floor(duration / 60)} hours ${duration % 60} minutes` : "N/A";
//   const durationFormatted = formatDuration(duration)
//   // const teacherRating = rating || "Not rated yet";
//   const formattedStartTime = formatStartTime(start_time);
//   const formatedExperience = formatExperience(experience)


//   const handleJoinClick = () => {
//     setOpenDialog(true); // Open the dialog
//   };



//   const handleConfirmAndJoin = () => {
//     if (isChecked) {
//       // Use navigate to redirect to the meeting link
//       window.open(course.meeting_link, '_blank'); // Open in a new tab
//       setOpenDialog(false); // Close the dialog
//     } else {
//       alert('Please confirm that you understand the instructions.');
//     }
//   };

//   const handleCheckboxChange = (event) => {
//     setIsChecked(event.target.checked); // Update checkbox state
//   };




//   const handleShareClick = () => {
//     // Handle share click (open sharing options or logic)
//   };


//   const handleRedirect = () => {
//     navigate('/meeting-guidelines');  // Redirect to meeting guidelines page
//   };

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };


//   return (
//     <div>
//       <Header1 userId={userId} onLogout={onLogout} />
   
//       <Box sx={{
//         backgroundColor: "#000000", minHeight: "100vh", marginTop: "50px", marginBottom: "100px", px: { xs: 2, sm: 3, md: 5 }, // Responsive horizontal padding
//         overflowX: "hidden",         // 💥 Prevent horizontal scroll
//         width: "100%",
//       }}>
//         <Grid
//           container
//           spacing={3}
//           justifyContent="center"
//           sx={{
//             backgroundColor: "#000000",
//             width: "100%",
//             margin: 0,
//             padding: 0,
//             overflowX: "hidden", // 💥 Just in case something leaks here
//           }}
//         >

//           <Grid item xs={12} sm={10} md={8} lg={8}>
//             <Box sx={{
//               position: 'relative',
//               padding: { xs: "1.5rem", sm: "2rem", md: "3rem", lg: "4rem" },// Responsive padding
//               backgroundColor: "#2222", // Darker background for modern look
//               color: "#fff",
//               borderRadius: "16px",
//               height: "100%",
//               boxSizing: "border-box",
//               boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
//               "&:hover": {
//                 transform: "translateY(-5px)",
//                 boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
//               },
//             }}>

//               {/* {media_type === 'video' ? (
//                 <Box
//                   component="video"
//                   src={media_url}
//                   controls
//                   sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
//                 />
//               ) : (
//                 <Box
//                   component="img"
//                   src={media_url}
//                   alt="media"
//                   sx={{ width: '100%', borderRadius: '12px', boxShadow: 3, mb: 2 }}
//                 />
//               )}
//  */}

//               <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'flex-end' }}>
//                 <ShareButton postUrl={`${window.location.origin}/share/post/${id}`} />
//               </Box>

//               <Typography
//                                               variant="h6"
//                                               sx={{
//                                                   fontWeight: 400,
//                                                   mt: "1.5rem",
//                                                   mb: "1.5rem",
//                                                   color: "#fff",
//                                                   letterSpacing: 1,
//                                                   textAlign: "left", // 👈 changed from "center" to "left"
//                                                   fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
//                                                   fontSize: {
//                                                       xs: '1rem',
//                                                       sm: '1.2rem',
//                                                       md: '1.2rem',
//                                                       lg: '1.2rem',
//                                                   },
//                                                   lineHeight: 1.6,
//                                                   "&:hover": {
//                                                       color: '#1E90FF',
//                                                   },
//                                               }}
//                                           >
//                                               {topic_name}
//                                           </Typography>

//               <Box
//                 sx={{
//                   position: 'relative',
//                   display: 'flex',
//                   flexDirection: 'row',
//                   alignItems: 'center',
//                   gap: 2, // replaces manual margin for spacing
//                   pt: '1rem',
//                 }}
//               >
//                 {/* <Avatar
//                   src={profile_picture ? `${API_URL}${profile_picture}` : '/default-avatar.png'}
//                   alt={`${name || 'User'} ${surname || ''}`}
//                   sx={{
//                     width: 50,
//                     height: 50,
//                     border: '2px solid #fff',
//                     boxShadow: '0 0 8px rgba(0,0,0,0.3)',
//                   }}
//                 /> */}

//                 <Avatar
//                                                                                             sx={{ width: 50, height: 50, bgcolor: '#0a2e57ff', fontSize: 28 }}
//                                                                                             src={profile_picture || undefined}
//                                                                                           >
//                                                                                             {!profile_picture && name
//                                                                                               ? name.charAt(0).toUpperCase()
//                                                                                               : null}
//                                                                                           </Avatar>

//                  <Tooltip title="Click to view" placement="bottom">
//                                                     <Typography
//                     variant="h6"
//                     onClick={() => navigate(`/expert-profile?expert_id=${user_id}`)}
//                     sx={{
//                         fontWeight: 'bold',
//                         color: '#fff',
//                         fontFamily: "'Helvetica', sans-serif",
//                         letterSpacing: '0.15em',
//                         fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },
//                         cursor: 'pointer',
//                         transition: 'color 0.3s ease-in-out',
//                         '&:hover': {
//                             color: '#1E90FF',
//                         },
//                     }}
//                 >
//                     {expert_name || 'Expert'}
//                 </Typography>
                
//                                                 </Tooltip>
//               </Box>

             

//                 {/* Description */}
//                                       <Grid item xs={12}>
//                                           <Typography
//                                               sx={{
//                                                   background: 'rgba(255, 255, 255, 0.05)',
//                                                   borderLeft: '4px solid #1976d2',
//                                                   padding: 2,
//                                                   mt:2,
//                                                   borderRadius: '8px',
//                                                   fontSize: '0.95rem',
//                                                   lineHeight: 1.6,
//                                                   color: '#e0e0e0',
//                                                   boxShadow: 'inset 0 0 5px rgba(255,255,255,0.05)',
//                                                   whiteSpace: 'pre-wrap',
//                                                   wordBreak: 'break-word',
//                                               }}
//                                           >
//                                               {description || 'No description provided.'}
//                                           </Typography>
//                                       </Grid>
              

//               <Grid container spacing={2} justifyContent="left" sx={{ mt: 1, mb: 5 }}>
//                 {/* Date + Time + Duration */}
//                 <Grid item xs={12} sm="auto">
//   <Typography
//     sx={{
//       display: 'inline-flex',
//       alignItems: 'center',
//       gap: { xs: 0.5, sm: 1 },
//       fontWeight: 600,
//       fontSize: { xs: '0.875rem', sm: '1rem' },
//       color: '#ffffff',
//       background: 'linear-gradient(135deg, #2079c2ff 0%, #1f2c33ff 100%)',
//       px: { xs: 1.5, sm: 2 },
//       py: { xs: 0.25, sm: 0.5 },
//       borderRadius: '18px',
//       boxShadow: '0 2px 10px rgba(48, 71, 83, 0.4)',
//       whiteSpace: 'nowrap',
//       textShadow: '0 1px 2px rgba(0,0,0,0.4)',
//       letterSpacing: 0.4,
//       userSelect: 'none',
//       width: 'fit-content',
//       maxWidth: '100%',
//       overflowX: 'auto', // Prevents overflow on very small screens
//       cursor: 'default',
//     }}
//   >
//     🗓
//     <span>
//       {formatTimeToAMPM(start_time)} • {formatDateWithSuffix(date)} • {durationFormatted}
//     </span>
//   </Typography>
// </Grid>


//                 {/* Language */}
//                 <Grid item>
//                   <Typography
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       fontWeight: '600',
//                       fontSize: '1rem',
//                       color: '#ffffff',
//                       background: 'linear-gradient(135deg, #c78b1cff, #27231aff)',
//                       px: 2,
//                       py: 0.5,
//                       borderRadius: '20px',
//                       boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
//                       letterSpacing: 0.3,
//                       whiteSpace: 'nowrap',
//                       textShadow: '0 0 4px rgba(0,0,0,0.25)',
//                       userSelect: 'none',
//                       cursor: 'default',
//                       width: 'fit-content',
//                     }}
//                   >
//                     🗣 {language || "N/A"}
//                   </Typography>
//                 </Grid>

//                 {/* Price */}
//                 <Grid item>
//                   <Typography
//                     sx={{
//                       display: 'inline-flex',
//                       alignItems: 'center',
//                       gap: 1,
//                       fontWeight: '600',
//                       fontSize: '1rem',
//                       color: '#ffffff',
//                       background: 'linear-gradient(135deg, #bcc71cff, #27231aff)',
//                       px: 2,
//                       py: 0.5,
//                       borderRadius: '20px',
//                       boxShadow: '0 0 10px rgba(160, 124, 45, 0.3)',
//                       letterSpacing: 0.3,
//                       whiteSpace: 'nowrap',
//                       textShadow: '0 0 4px rgba(0,0,0,0.25)',
//                       userSelect: 'none',
//                       cursor: 'default',
//                       width: 'fit-content',
//                     }}
//                   >
//                     ₹{price}
//                   </Typography>
//                 </Grid>
//               </Grid>



//               <Grid container spacing={2} justifyContent="center" alignItems="center" >


//               {booking?.status === "completed" && booking?.recording_url && (
//   <Box sx={{ mb: 3 }}>
//     <Typography variant="h6" sx={{ mb: 1 }}>
//       🎥 Session Recording
//     </Typography>

//     <video
//       src={booking.recording_url}
//       controls
//       style={{
//         width: "100%",
//         borderRadius: "12px",
//         boxShadow: "0 4px 20px rgba(0,0,0,0.5)"
//       }}
//     />
//   </Box>
// )}


//                 {/* <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
//                   <JoinAsSubscriberButton userId={userId} postId={id} />
//                 </Grid> */}
//                 <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
//                                   <Button
//                                     variant="contained"
//                                     color="success"
//                                     href={meeting_link || '#'}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     disabled={status === "completed"}
//                                     sx={{
//                                       borderRadius: '20px',
//                                       px: 4,
//                                       py: 1.5,
//                                       fontWeight: 600,
//                                       textTransform: 'none',
//                                       boxShadow: '0 4px 12px rgba(0, 128, 0, 0.3)',
//                                       '&:hover': {
//                                         boxShadow: meeting_link
//                                           ? '0 6px 16px rgba(0, 128, 0, 0.5)'
//                                           : 'none',
//                                       },
//                                     }}
//                                   >
//                                     Join Meeting
//                                   </Button>
//                                 </Grid>

//                 {/* <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
//                   <CancelSessionPostBookingButton postId={id} userId={userId} />
//                 </Grid> */}

                


//               </Grid>
//               {/* <OTPValidation postId={id} userId={userId} /> */}



//               <Box>
//                 {is_active === false && (
//                   <Typography variant="h6" color="error" sx={{ letterSpacing: 2 }}>
//                     Session has been cancelled.
//                   </Typography>
//                 )}
//               </Box>




//               <Box sx={{ textAlign: 'center', marginTop: '2rem', padding: '1rem', width: '100%' }}>





//               </Box>

//               {/* <FeedbackFormMyBookings userId={userId} postId={id} /> */}


//             </Box>
//           </Grid>

//           <Grid container spacing={2} sx={{
//             justifyContent: "center", marginTop: "5px", backgroundColor: '#000000', borderColor: '#5555',
//             borderRadius: "15px",
//             "&:hover": {
//               borderColor: '#1E90FF',
//             },
//           }}>





//             <div>

//               <Dialog
//                 open={openDialog}
//                 onClose={() => setOpenDialog(false)}
//                 PaperProps={{
//                   sx: {
//                     backgroundColor: '#1e1e1e',
//                     color: '#e0e0e0',
//                     borderRadius: 2,
//                     minWidth: { xs: '90%', sm: 600 },
//                     maxHeight: '90vh',
//                   },
//                 }}
//               >
//                 <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
//                   <MeetingGuidelines />

//                   <Box sx={{ mt: 3 }}>
//                     <FormControlLabel
//                       control={
//                         <Checkbox
//                           checked={isChecked}
//                           onChange={handleCheckboxChange}
//                           sx={{
//                             color: '#bb86fc',
//                             '&.Mui-checked': {
//                               color: '#bb86fc',
//                             },
//                           }}
//                         />
//                       }
//                       label={
//                         <Typography variant="body2" sx={{ color: '#e0e0e0', letterSpacing: 2 }}>
//                           I acknowledge that I have read, understood, and agree to all the terms and conditions outlined above.
//                         </Typography>
//                       }
//                     />
//                   </Box>
//                 </DialogContent>

//                 <DialogActions sx={{ px: 3, pb: 3 }}>
//                   <Button
//                     onClick={() => setOpenDialog(false)}
//                     variant="outlined"
//                     color="secondary"
//                     sx={{ letterSpacing: 3 }}
//                   >
//                     Cancel
//                   </Button>
//                   <Button
//                     onClick={handleConfirmAndJoin}
//                     variant="contained"
//                     color="primary"
//                     disabled={!isChecked}
//                     sx={{
//                       backgroundColor: !isChecked ? '#555' : '#1976d2',
//                       letterSpacing: 3,
//                       '&:hover': {
//                         backgroundColor: !isChecked ? '#555' : '#1565c0',
//                       },
//                     }}
//                   >
//                     Confirm and Join
//                   </Button>
//                 </DialogActions>
//               </Dialog>
// {loading && (
//                               <Box
//                                 sx={{
//                                   position: 'fixed',
//                                   top: 0,
//                                   left: 0,
//                                   width: '100vw',
//                                   height: '100vh',
//                                   backgroundColor: 'rgba(0, 0, 0, 0.5)',
//                                   zIndex: 2000,
//                                   display: 'flex',
//                                   alignItems: 'center',
//                                   justifyContent: 'center',
//                                   backdropFilter: 'blur(3px)',
//                                 }}
//                               >
//                                 <Box sx={{ textAlign: 'center' }}>
//                                   <CircularProgress
//                       size={60}
//                       thickness={6}
//                       sx={{
//                         color: 'transparent',
//                         '& .MuiCircularProgress-circle': {
//                           stroke: 'url(#better-gradient)',
//                         },
//                       }}
//                     />
                    
//                     <svg width="0" height="0">
//                       <defs>
//                         <linearGradient id="better-gradient" x1="1" y1="0" x2="0" y2="1">
//                           <stop offset="0%" stopColor="#f30b96ff" />     {/* pinkish-purple */}
//                           <stop offset="50%" stopColor="#221ce0ff" />     {/* deep lavender */}
//                           <stop offset="100%" stopColor="#0eacebff" />    {/* bright sky blue */}
//                         </linearGradient>
//                       </defs>
//                     </svg>
                    
//                                   <Typography
//                                     variant="h6"
//                                     sx={{
//                                       mt: 2,
//                                       color: '#fff',
//                                       textShadow: '0 1px 3px rgba(0,0,0,0.7)',
//                                     }}
//                                   >
//                                     Loading Session Details... ({loadingSeconds} sec)
//                                   </Typography>
//                                 </Box>
//                               </Box>
//                             )}

//             </div>





//           </Grid>



//         </Grid>



//       </Box>

//       <IconButton
//         onClick={scrollToTop}
//         sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
//         <ArrowUpwardIcon />
//       </IconButton>
//       <Footer2 />
//     </div>
//   );
// };

// export default MyBookingTabDetails;


// import React, { useState, useEffect } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useAuth } from "../../AuthContext";
// import {
// Box,
// Grid,
// Typography,
// Button,
// CircularProgress
// } from "@mui/material";
// import Header1 from "../Header/Header1";
// import Footer2 from "../Footer/Footer2";

// const API_URL = process.env.REACT_APP_API_URL;

// const MyBookingTabDetails = ({ onLogout }) => {
// const { bookingId } = useParams();
// const { userId } = useAuth();
// const navigate = useNavigate();

// const [booking, setBooking] = useState(null);
// const [loading, setLoading] = useState(true);

// // ✅ Fetch booking only (no post API)
// useEffect(() => {
// const fetchBooking = async () => {
// try {
// const res = await fetch(
// `${API_URL}/get_booking_details/?booking_id=${bookingId}`
// );


//     if (!res.ok) {
//       const text = await res.text();
//       console.error("API ERROR:", text);
//       return;
//     }

//     const data = await res.json();
//     console.log("BOOKING DATA:", data);
//     setBooking(data);
//   } catch (err) {
//     console.error("Booking fetch error:", err);
//   } finally {
//     setLoading(false);
//   }
// };

// if (bookingId) fetchBooking();

// }, [bookingId]);

// // ✅ Format helpers
// const formatTime = (time) => {
// if (!time) return "";
// const [h, m] = time.split(":");
// const d = new Date();
// d.setHours(h);
// d.setMinutes(m);
// return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
// };

// const formatDuration = (min) => {
// if (!min) return "";
// const h = Math.floor(min / 60);
// const m = min % 60;
// return h > 0 ? `${h}h ${m}m` : `${m}m`;
// };

// // ✅ Loading state
// if (loading) {
// return (
// <Box sx={{ textAlign: "center", mt: 10 }}> <CircularProgress />
// <Typography sx={{ mt: 2, color: "#fff" }}>
// Loading session... </Typography> </Box>
// );
// }

// // ✅ Safety check
// if (!booking) {
// return (
// <Typography sx={{ color: "white", textAlign: "center", mt: 5 }}>
// Booking not found </Typography>
// );
// }

// const {
// topic_name,
// expert_name,
// date,
// time,
// duration,
// status,
// recording_url
// } = booking;

// return ( <div> <Header1 userId={userId} onLogout={onLogout} />

//   <Box
//     sx={{
//       minHeight: "100vh",
//       background: "#000",
//       px: 3,
//       py: 5
//     }}
//   >
//     <Grid container justifyContent="center">
//       <Grid item xs={12} md={8}>
//         <Box
//           sx={{
//             background: "#111",
//             p: 4,
//             borderRadius: 3,
//             color: "#fff"
//           }}
//         >
//           {/* ✅ Title */}
//           <Typography variant="h5" sx={{ mb: 2 }}>
//             {topic_name}
//           </Typography>

//           {/* ✅ Expert */}
//           <Typography sx={{ mb: 1 }}>
//             👤 Expert: {expert_name}
//           </Typography>

//           {/* ✅ Date + Time */}
//           <Typography sx={{ mb: 1 }}>
//             🗓 {date} • {formatTime(time)}
//           </Typography>

//           {/* ✅ Duration */}
//           <Typography sx={{ mb: 2 }}>
//             ⏱ Duration: {formatDuration(duration)}
//           </Typography>

//           {/* ✅ Status */}
//           <Typography sx={{ mb: 3 }}>
//             📌 Status:{" "}
//             <span style={{ color: status === "completed" ? "#4caf50" : "#ff9800" }}>
//               {status}
//             </span>
//           </Typography>

//           {/* ✅ Recording */}
//           {status === "completed" && recording_url && (
//             <Box sx={{ mb: 3 }}>
//               <Typography variant="h6" sx={{ mb: 1 }}>
//                 🎥 Session Recording
//               </Typography>

//               <video
//                 src={recording_url}
//                 controls
//                 style={{
//                   width: "100%",
//                   borderRadius: "10px"
//                 }}
//               />
//             </Box>
//           )}

//           {/* ✅ Join Button */}
//           <Button
//             variant="contained"
//             color="success"
//             disabled={status === "completed"}
//             sx={{ mt: 2 }}
//           >
//             Join Meeting
//           </Button>
//         </Box>
//       </Grid>
//     </Grid>
//   </Box>

//   <Footer2 />
// </div>

// );
// };

// export default MyBookingTabDetails;
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";
import Header1 from "../Header/Header1";
import Footer2 from "../Footer/Footer2";

const API_URL = process.env.REACT_APP_API_URL;

const STATUS_CONFIG = {
  completed:  { label: "Completed",  color: "#4ade80", bg: "#0d2e1a", border: "#1a4d2a", dot: "#4ade80" },
  pending:    { label: "Pending",    color: "#f59e0b", bg: "#2e1f05", border: "#4a3008", dot: "#f59e0b" },
  confirmed:  { label: "Confirmed",  color: "#60a5fa", bg: "#0d1a2e", border: "#1a3d5c", dot: "#60a5fa" },
  cancelled:  { label: "Cancelled",  color: "#f87171", bg: "#2e0d0d", border: "#5c1a1a", dot: "#f87171" },
};

const getInitials = (name = "") =>
  name.split(" ").map(w => w[0]).join("").toUpperCase().slice(0, 2);

const formatTime = (time) => {
  if (!time) return "";
  const [h, m] = time.split(":");
  const d = new Date();
  d.setHours(h); d.setMinutes(m);
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
};

const formatDuration = (min) => {
  if (!min) return "";
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h > 0 ? `${h}h ${m}m` : `${m}m`;
};

const formatDate = (dateStr) => {
  if (!dateStr) return "";
  return new Date(dateStr).toLocaleDateString("en-IN", {
    day: "numeric", month: "short", year: "numeric",
  });
};

// ── small inline SVG icons ──────────────────────────────────────────────────
const IconPlay = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <path d="M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1z" stroke="#4ade80" strokeWidth="1.2"/>
    <path d="M6 5.5l5 2.5-5 2.5V5.5z" fill="#4ade80"/>
  </svg>
);
const IconCal = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <rect x="2" y="3" width="12" height="11" rx="2" stroke="#888" strokeWidth="1.2"/>
    <path d="M5 1v3M11 1v3M2 7h12" stroke="#888" strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);
const IconVideo = () => (
  <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
    <rect x="1" y="4" width="10" height="8" rx="2" stroke="#555" strokeWidth="1.2"/>
    <path d="M11 6.5l4-2v7l-4-2V6.5z" stroke="#555" strokeWidth="1.2" strokeLinejoin="round"/>
  </svg>
);
const IconBack = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M9 2L4 7l5 5" stroke="#555" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

// ── reusable tile ───────────────────────────────────────────────────────────
const MetaTile = ({ label, value }) => (
  <Box sx={{
    background: "#161618", border: "0.5px solid #1e1e1e",
    borderRadius: "10px", p: "14px 16px",
  }}>
    <Box sx={{ fontSize: 11, color: "#555", textTransform: "uppercase", letterSpacing: "0.06em", mb: "5px" }}>
      {label}
    </Box>
    <Box sx={{ fontSize: 14, color: "#d0d0d0", fontWeight: 500 }}>{value}</Box>
  </Box>
);

export default function MyBookingTabDetails({ onLogout }) {
  const { bookingId } = useParams();
  const { userId } = useAuth();
  const navigate = useNavigate();

  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooking = async () => {
      try {
        const res = await fetch(`${API_URL}/get_booking_details/?booking_id=${bookingId}`);
        if (!res.ok) { console.error("API ERROR:", await res.text()); return; }
        const data = await res.json();
        console.log("BOOKING DATA:", data);
        setBooking(data);
      } catch (err) {
        console.error("Booking fetch error:", err);
      } finally {
        setLoading(false);
      }
    };
    if (bookingId) fetchBooking();
  }, [bookingId]);

  if (loading) {
    return (
      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#09090b", gap: 2 }}>
        <CircularProgress sx={{ color: "#333" }} size={28} />
        <Typography sx={{ color: "#555", fontSize: 13 }}>Loading session…</Typography>
      </Box>
    );
  }

  if (!booking) {
    return (
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#09090b" }}>
        <Typography sx={{ color: "#555", fontSize: 14 }}>Booking not found</Typography>
      </Box>
    );
  }

  const { topic_name, expert_name, date, time, duration, status, recording_url, booking_id } = booking;
  const s = STATUS_CONFIG[status] || STATUS_CONFIG.pending;

  return (
    <div style={{ background: "#09090b", minHeight: "100vh" }}>
      <Header1 userId={userId} onLogout={onLogout} />

      <Box sx={{ px: { xs: "16px", sm: "24px" }, py: "40px", maxWidth: "720px", mx: "auto" }}>

        {/* back button */}
        <Box
          component="button"
          onClick={() => navigate(-1)}
          sx={{ display: "inline-flex", alignItems: "center", gap: "6px", fontSize: 13, color: "#555", background: "none", border: "none", cursor: "pointer", mb: "28px", p: 0, "&:hover": { color: "#999" } }}
        >
          <IconBack /> Back to my bookings
        </Box>

        {/* main card */}
        <Box sx={{ background: "#111113", border: "0.5px solid #222", borderRadius: "16px", overflow: "hidden" }}>

          {/* hero */}
          <Box sx={{ background: "#141416", borderBottom: "0.5px solid #1e1e1e", p: "28px 28px 24px" }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px", mb: "20px" }}>
              <Box sx={{ fontSize: 20, fontWeight: 600, color: "#f0f0f0", lineHeight: 1.3 }}>
                {topic_name}
              </Box>
              <Box sx={{
                fontSize: 11, fontWeight: 500, px: "10px", py: "4px",
                borderRadius: "20px", whiteSpace: "nowrap", flexShrink: 0, mt: "3px",
                color: s.color, background: s.bg, border: `0.5px solid ${s.border}`,
                display: "flex", alignItems: "center", gap: "5px",
              }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", background: s.dot, flexShrink: 0 }} />
                {s.label}
              </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <Box sx={{
                width: 36, height: 36, borderRadius: "50%", background: "#1e1e28",
                border: "0.5px solid #2a2a3a", display: "flex", alignItems: "center",
                justifyContent: "center", fontSize: 13, fontWeight: 500, color: "#818cf8", flexShrink: 0,
              }}>
                {getInitials(expert_name)}
              </Box>
              <Box>
                <Box sx={{ fontSize: 14, color: "#d0d0d0", fontWeight: 500 }}>{expert_name}</Box>
                <Box sx={{ fontSize: 11, color: "#555", mt: "1px" }}>Your expert</Box>
              </Box>
            </Box>
          </Box>

          {/* body */}
          <Box sx={{ p: "24px 28px", display: "flex", flexDirection: "column", gap: "20px" }}>

            {/* meta tiles */}
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "12px" }}>
              <MetaTile label="Date" value={formatDate(date)} />
              <MetaTile label="Time" value={formatTime(time)} />
              <MetaTile label="Duration" value={formatDuration(duration)} />
              <MetaTile label="Session type" value="1-on-1 call" />
            </Box>

            <Box sx={{ height: "0.5px", background: "#1a1a1a" }} />

            {/* recording section */}
            <Box>
              <Box sx={{ fontSize: 11, color: "#555", textTransform: "uppercase", letterSpacing: "0.06em", mb: "12px" }}>
                Session recording
              </Box>

              {status === "completed" && recording_url ? (
                <Box sx={{ background: "#161618", border: "0.5px solid #1e1e1e", borderRadius: "10px", overflow: "hidden" }}>
                  <video src={recording_url} controls style={{ width: "100%", display: "block" }} />
                </Box>
              ) : (
                <Box sx={{
                  background: "#161618", border: "0.5px solid #1e1e1e", borderRadius: "10px",
                  display: "flex", alignItems: "center", gap: "10px", p: "20px 16px",
                  color: "#555", fontSize: 13,
                }}>
                  <Box sx={{
                    width: 32, height: 32, borderRadius: "8px", background: "#1a1a1a",
                    border: "0.5px solid #222", display: "flex", alignItems: "center", justifyContent: "center",
                  }}>
                    <IconVideo />
                  </Box>
                  {status === "completed"
                    ? "No recording available for this session"
                    : "Recording will be available after the session completes"}
                </Box>
              )}
            </Box>

            <Box sx={{ height: "0.5px", background: "#1a1a1a" }} />

            {/* action buttons */}
            {/* <Box sx={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Box
                component="button"
                disabled={status === "completed"}
                sx={{
                  display: "inline-flex", alignItems: "center", gap: "7px",
                  px: "20px", py: "10px", borderRadius: "10px", fontSize: 13,
                  fontWeight: 500, cursor: status === "completed" ? "not-allowed" : "pointer",
                  background: status === "completed" ? "#161618" : "#1a3d1a",
                  color: status === "completed" ? "#3a3a3a" : "#4ade80",
                  border: `0.5px solid ${status === "completed" ? "#222" : "#2a5c2a"}`,
                  fontFamily: "inherit", transition: "background 0.15s",
                }}
              >
                {status !== "completed" && <IconPlay />}
                Join meeting
              </Box> */}

              {/* <Box
                component="button"
                sx={{
                  display: "inline-flex", alignItems: "center", gap: "7px",
                  px: "20px", py: "10px", borderRadius: "10px", fontSize: 13,
                  fontWeight: 500, cursor: "pointer", background: "#1a1a1a",
                  color: "#888", border: "0.5px solid #222", fontFamily: "inherit",
                }}
              >
                <IconCal /> Reschedule
              </Box> */}
            {/* </Box> */}
          </Box>

          {/* footer bar */}
          <Box sx={{
            background: "#161618", borderTop: "0.5px solid #1e1e1e",
            px: "28px", py: "14px", display: "flex", alignItems: "center", justifyContent: "space-between",
          }}>
            <Box sx={{ fontSize: 12, color: "#555" }}>Booking ID</Box>
            <Box sx={{ fontSize: 12, fontWeight: 500, color: "#888" }}>#{booking_id}</Box>
          </Box>
        </Box>

        <Box sx={{ mt: "16px", textAlign: "center", fontSize: 12, color: "#333" }}>
          Join link will be active closer to the scheduled time
        </Box>
      </Box>

      <Footer2 />
    </div>
  );
}